const AddonActionTypes = {
  START_FETCH_ALL_ADDONS: 'START_FETCH_ALL_ADDONS',
  FETCH_ALL_ADDONS_SUCCESS: 'FETCH_ALL_ADDONS_SUCCESS',
  FETCH_ALL_ADDONS_FAILURE: 'FETCH_ALL_ADDONS_FAILURE',

  UPDATE_ADDON: 'UPDATE_ADDON',
  UPDATE_ADDON_SUCCESS: 'UPDATE_ADDON_SUCCESS',
  UPDATE_ADDON_FAILURE: 'UPDATE_ADDON_FAILURE',

  FETCH_ORG_ADDONS: 'FETCH_ORG_ADDONS',
  FETCH_ORG_ADDONS_SUCCESS: 'FETCH_ORG_ADDONS_SUCCESS',
  FETCH_ORG_ADDONS_FAILURE: 'FETCH_ORG_ADDONS_FAILURE',

  SET_ANY_DATA: 'SET_ANY_DATA',
};

export default AddonActionTypes;
